import React from 'react'

const SalesAiChat = () => {
  return (
    <div>SalesAiChat</div>
  )
}

export default SalesAiChat